/**
 * Generate from url: https://localhost:44305/swagger/v1/swagger.json
 * It is recommended not to modify the document
 * Total count: 1
 **/
import type {
  SendSmsSecurityCodeInput,
  VertifySmsSecurityCodeInput,
} from './types';
import { api } from 'boot/axios';

/**
 * *TODO* POST /api/app/security/send-security-code
 **/
export function sendSmsSecurityCode(payload: SendSmsSecurityCodeInput) {
  return api.post<void>('/api/app/security/send-sms-security-code', {
    ...payload,
  });
}

/**
 * *TODO* POST /api/app/security/send-security-code
 **/
export function vertifySmsSecurityCode(payload: VertifySmsSecurityCodeInput) {
  return api.post<void>('/api/app/security/vertify-sms-security-code', {
    ...payload,
  });
}

export default {
  sendSmsSecurityCode,
  vertifySmsSecurityCode,
};
